import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { Modal, Pagination } from 'react-bootstrap';
import FileUploader from '../components/FileUploader/FileUploader';
import { getBanksAction, deleteBankAction, createBankAction, updateBankAction } from '../../store/actions/bank/BankActions';
import property1 from '../../images/property/1.jpg'

const Bank = () => {
	const dispatch = useDispatch();

	// Use correct reducer and loading state
	const { banks, loading } = useSelector((state) => state.bank);
	const bankRows = banks?.rows || [];
	const totalPages = banks?.pages || 1;
	const [formErrors, setFormErrors] = useState({});

	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize] = useState(10);
	const [addCard, setAddCard] = useState(false);

	const [addFormData, setAddFormData] = useState({
		name: '',
		shortCode: '',
		ifscPrefix: '',
		logoUrl: '',
		country: '',
		isSupported: true,
		isEnabled: true,
		isDeleted: false,
	});
	const [media, setMedia] = useState([]);
	const [editMode, setEditMode] = useState(false);
	const [editBankData, setEditBankData] = useState(null);

	const handleAddFormChange = (e) => {
		const { name, value } = e.target;
		const updatedValue = (value === 'true' || value === 'false') ? JSON.parse(value) : value;

		setAddFormData(prev => ({
			...prev,
			[name]: updatedValue
		}));

		setFormErrors((prevErrors) => ({
			...prevErrors,
			[name]: ''
		}));
	};

	const handleAddFormSubmit = async (event) => {
		event.preventDefault();

		const {
			name,
			shortCode,
			ifscPrefix,
			country,
			isSupported,
			isEnabled,
			isDeleted
		} = addFormData;

		const errors = {};

		// Validation
		if (!name.trim()) errors.name = "Name is required.";
		if (!shortCode.trim()) errors.shortCode = "Short code is required.";
		if (!ifscPrefix.trim()) errors.ifscPrefix = "IFSC prefix is required.";
		if (media.length === 0) {
			errors.logoUrl = "Logo is required.";
		}
		if (!country.trim()) errors.country = "Country is required.";

		setFormErrors(errors);

		if (Object.keys(errors).length > 0) return;

		const bankPayload = {
			name,
			shortCode,
			ifscPrefix,
			logoUrl : media[0],
			country,
			isSupported,
			isEnabled,
			isDeleted
		};

		try {
			let response;
			if (editMode && editBankData?._id) {
				response = await dispatch(updateBankAction(editBankData._id, bankPayload));
			} else {
				response = await dispatch(createBankAction(bankPayload));
			}

			if (response.data.success) {
				Swal.fire({
					icon: 'success',
					title: 'Success!',
					text: editMode ? 'Bank updated' : 'Bank added'
				});
				resetForm();
				dispatch(getBanksAction(currentPage, pageSize));
			} else {
				Swal.fire({
					icon: 'error',
					title: 'Error',
					text: response.data?.msg || 'Something went wrong'
				});
			}
		} catch (error) {
			Swal.fire({
			icon: 'error',
			title: 'Error',
			text: error?.response?.data?.msg || 'Unexpected error occurred'
			});
		}
	};


	const handleDelete = async (bankId) => {
		const result = await Swal.fire({
			title: "Are you sure?",
			text: "You won't be able to revert this!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, delete it!"
		});

		if (result.isConfirmed) {
			const response = await dispatch(deleteBankAction(bankId));
			if (response.data.success) {
				Swal.fire("Deleted!", "The bank has been deleted.", "success");
				dispatch(getBanksAction(currentPage, pageSize));
			} else {
				Swal.fire("Deleted!", "Check.", "Test");
			}
		}
	};

	const handleEdit = (bank) => {
		setEditMode(true);
		setEditBankData(bank);
		setFormErrors({});
		setMedia(bank.logoUrl ? [bank.logoUrl] : []);
		setAddFormData({
			name: bank.name || '',
			shortCode: bank.shortCode || '',
			ifscPrefix: bank.ifscPrefix || '',
			logoUrl: bank.logoUrl || '',
			country: bank.country || '',
			isSupported: bank.isSupported ?? true,
			isEnabled: bank.isEnabled ?? true,
			isDeleted: bank.isDeleted ?? false
		});

		setAddCard(true);
	};

	const resetForm = () => {
		setAddCard(false);
		setEditMode(false);
		setEditBankData(null);
		setAddFormData({
			name: '',
			isEnabled: true
		});
	};

	// const searchRole = () => {
	// 	dispatch(getBanksAction(currentPage, pageSize, searchTerm));
	// }

	useEffect(() => {
		dispatch(getBanksAction(currentPage, pageSize));
	}, [dispatch, currentPage, pageSize]);

	useEffect(() => {
		// dispatch(getAllPoliciesAction());
	}, [dispatch]);

	return (
		<>
			<div className="col-12">
				<Modal className="modal fade" show={addCard} onHide={resetForm}>
					<form onSubmit={handleAddFormSubmit}>
						<div className="modal-header">
						<h4 className="modal-title fs-20">{editMode ? 'Edit Bank' : 'Add Bank'}</h4>
						<button type="button" className="btn-close" onClick={resetForm}></button>
						</div>
						<div className="modal-body">
						<div className="add-contact-box">
							<div className="add-contact-content">
							{/* Name */}
							<div className="form-group mb-3">
								<label>Name</label>
								<input
								type="text"
								className={`form-control ${formErrors.name ? 'is-invalid' : ''}`}
								name="name"
								value={addFormData.name}
								onChange={handleAddFormChange}
								placeholder="Bank Name"
								/>
								{formErrors.name && <div className="invalid-feedback">{formErrors.name}</div>}
							</div>

							{/* Short Code */}
							<div className="form-group mb-3">
								<label>Short Code</label>
								<input
								type="text"
								className={`form-control ${formErrors.shortCode ? 'is-invalid' : ''}`}
								name="shortCode"
								value={addFormData.shortCode}
								onChange={handleAddFormChange}
								placeholder="Short Code"
								/>
								{formErrors.shortCode && <div className="invalid-feedback">{formErrors.shortCode}</div>}
							</div>

							{/* IFSC Prefix */}
							<div className="form-group mb-3">
								<label>IFSC Prefix</label>
								<input
								type="text"
								className={`form-control ${formErrors.ifscPrefix ? 'is-invalid' : ''}`}
								name="ifscPrefix"
								value={addFormData.ifscPrefix}
								onChange={handleAddFormChange}
								placeholder="IFSC Prefix"
								/>
								{formErrors.ifscPrefix && <div className="invalid-feedback">{formErrors.ifscPrefix}</div>}
							</div>

							{/* Logo URL */}
							<div className="form-group mb-3">
								<label>Logo</label>
								<FileUploader
									files={media}
									onFilesChange={(newFiles) => setMedia(newFiles)}
									multiple={false}
									acceptImagesOnly={true}
								/>
								{formErrors.logoUrl && <div className="text-danger mt-1">{formErrors.logoUrl}</div>}
							</div>

							{/* Country */}
							<div className="form-group mb-3">
								<label>Country</label>
								<input
								type="text"
								className={`form-control ${formErrors.country ? 'is-invalid' : ''}`}
								name="country"
								value={addFormData.country}
								onChange={handleAddFormChange}
								placeholder="Country"
								/>
								{formErrors.country && <div className="invalid-feedback">{formErrors.country}</div>}
							</div>

							{/* Is Supported */}
							<div className="form-group mb-3">
								<label>Supported</label>
								<select
								name="isSupported"
								className={`form-control ${formErrors.isSupported ? 'is-invalid' : ''}`}
								value={addFormData.isSupported}
								onChange={handleAddFormChange}
								>
								<option value={true}>Yes</option>
								<option value={false}>No</option>
								</select>
								{formErrors.isSupported && <div className="invalid-feedback">{formErrors.isSupported}</div>}
							</div>

							{/* Is Enabled */}
							<div className="form-group mb-3">
								<label>Status</label>
								<select
								name="isEnabled"
								className={`form-control ${formErrors.isEnabled ? 'is-invalid' : ''}`}
								value={addFormData.isEnabled}
								onChange={handleAddFormChange}
								>
								<option value={true}>Enabled</option>
								<option value={false}>Disabled</option>
								</select>
								{formErrors.isEnabled && <div className="invalid-feedback">{formErrors.isEnabled}</div>}
							</div>

							{/* Is Deleted */}
							<div className="form-group mb-3">
								<label>Deleted</label>
								<select
								name="isDeleted"
								className={`form-control ${formErrors.isDeleted ? 'is-invalid' : ''}`}
								value={addFormData.isDeleted}
								onChange={handleAddFormChange}
								>
								<option value={false}>No</option>
								<option value={true}>Yes</option>
								</select>
								{formErrors.isDeleted && <div className="invalid-feedback">{formErrors.isDeleted}</div>}
							</div>
							</div>
						</div>
						</div>
						<div className="modal-footer">
						<button type="submit" className="btn btn-primary">{editMode ? "Update" : "Add"}</button>
						<button type="button" onClick={resetForm} className="btn btn-danger">Discard</button>
						</div>
					</form>
				</Modal>

				<div className="card">
					<div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-3">
						<h4 className="card-title mb-0">Bank List</h4>
						
						{/* <div className="input-group w-50">
							<input
								type="text"
								className="form-control"
								placeholder="Search by name..."
								onChange={(e) => setSearchTerm(e.target.value)} 
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										searchRole();
									}
								}}
							/>
							<span onClick={searchRole} className="input-group-text" style={{ cursor: 'pointer' }}>
								<i className="fa fa-search"></i>
							</span>
						</div> */}

						<button className="btn btn-primary shadow btn-xs sharp me-2" onClick={() => setAddCard(true)}>
							<i className="fa fa-plus"></i>
						</button>
					</div>
					<div className="card-body">
						<div className="table-responsive">
							<table className="table table-striped">
								<thead>
									<tr>
										<th>Name</th>
										<th>Logo</th>
										<th>IFSC Prefix</th>
										<th>Enabled</th>
										<th>Action</th>
									</tr>
								</thead>
								<tbody>
									{loading ? (
										// Skeleton loader rows
										Array.from({ length: 5 }).map((_, idx) => (
											<tr key={idx}>
												<td><span className="skeleton-box" style={{ width: '80px', height: '20px', display: 'inline-block' }} /></td>
												<td><span className="skeleton-box" style={{ width: '50px', height: '50px', display: 'inline-block' }} /></td>
												<td><span className="skeleton-box" style={{ width: '60px', height: '20px', display: 'inline-block' }} /></td>
												<td><span className="skeleton-box" style={{ width: '60px', height: '20px', display: 'inline-block' }} /></td>
												<td><span className="skeleton-box" style={{ width: '100px', height: '20px', display: 'inline-block' }} /></td>
											</tr>
										))
									) : bankRows.length === 0 ? (
										<tr>
											<td colSpan={5} className="text-center text-muted">No banks found</td>
										</tr>
									) : (
										bankRows.map((bank) => (
											<tr key={bank._id}>
												<td>{bank.name+"("+bank.shortCode+")"}</td>
												<td>
													<img 
														src={bank.logoUrl} 
														alt="/" 
														height={50}
														width={50}
														onError={(e) => {
															e.target.onerror = null; 
															e.target.src = property1; 
														}}
													/>
												</td>
												<td>{bank.ifscPrefix}</td>
												<td className={bank.isEnabled ? 'text-success' : 'text-danger'}>
													{bank.isEnabled ? 'True' : 'False'}
												</td>
												<td>
													<div className="d-flex">
														<button className="btn btn-secondary shadow btn-xs sharp me-2" onClick={() => handleEdit(bank)}>
															<i className="fa fa-pencil"></i>
														</button>
														<button className="btn btn-danger shadow btn-xs sharp" onClick={() => handleDelete(bank._id)}>
															<i className="fa fa-trash"></i>
														</button>
													</div>
												</td>
											</tr>
										))
									)}
								</tbody>
							</table>
						</div>

						<div className="d-flex justify-content-between align-items-center mt-4">
							<div></div> {/* Empty div to align right side content */}
							<div className="d-flex align-items-center gap-3">
								<span className="text-muted">Total Policies: {banks?.total || bankRows.length}</span>
								<Pagination className="pagination-gutter pagination-circle pagination mb-0">
									<Pagination.Prev
										disabled={currentPage === 1}
										onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
									/>
									{Array.from({ length: totalPages }, (_, i) => (
										<Pagination.Item
											key={i + 1}
											active={i + 1 === currentPage}
											onClick={() => setCurrentPage(i + 1)}
										>
											{i + 1}
										</Pagination.Item>
									))}
									<Pagination.Next
										disabled={currentPage === totalPages}
										onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
									/>
								</Pagination>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Bank;
